import { Nav } from 'react-bootstrap';
import { NavItemWrapper, NavWrapper } from '../styles';

interface IProps {
    activeKey: string,
    isAdmin: boolean,
    isAdminLogin: boolean,
    centerId: number
}

const FollowUpReportsNav = (props: IProps) => {
    const hrefPrefix = !props.isAdmin ? `/center/${props.centerId}/follow-up/reports` : `/admin/follow-up/reports`;

    const list = [
        { key: 'COMPLIANCE', title: 'Follow-Up Compliance Report', href: hrefPrefix + '/compliance' },
        // { key: 'SURVEYS', title: 'Follow-Up Survey Report', href: hrefPrefix + '/surveys' },
        { key: 'RECONCILIATION', title: 'Follow-Up Reconciliation Report', href: hrefPrefix + '/reconciliation' },
    ]

    return (
        <NavWrapper>
            <div style={{ padding: '5px 5px 20px 5px', backgroundColor: 'white' }}>
                <Nav bsStyle='pills' className='ms-pills'>
                    {list.map((item, index) =>
                        <>
                            {index > 0 && (
                                <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>
                            )}
                            <NavItemWrapper active={props.activeKey == item.key} href={item.href}>
                                {item.title}
                            </NavItemWrapper>
                        </>
                    )}
                </Nav>
            </div>
        </NavWrapper>
    )
}

export default FollowUpReportsNav;